"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _useLabel = _interopRequireDefault(require("../../hooks/useLabel"));
var _InputNumber = _interopRequireDefault(require("../Input/InputNumber"));
var _InputCurrency = _interopRequireDefault(require("../Input/InputCurrency"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * The RangeSlider component allows an user to enter data into the application.
 */
const RangeSlider = props => {
  const {
    id: controlledId,
    label: initialLabel,
    helper,
    min,
    max,
    displayTooltip,
    value,
    step,
    onChange,
    double,
    locale,
    displaySuffix,
    displayCurrency,
    leftEdge,
    leftCustomEdge,
    rightEdge,
    rightCustomEdge,
    // readOnly,
    disabled,
    // required,
    className
  } = props;
  const id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  const [minValue, setMinValue] = _react.default.useState(double ? 0 : value ? value.min : min);
  const [maxValue, setMaxValue] = _react.default.useState(value ? value.max : max);
  _react.default.useEffect(() => {
    if (value) {
      setMinValue(value.min);
      setMaxValue(value.max);
    }
  }, [value]);

  // const [errors] = useFormElementValidation(value, {
  //     required,
  // });
  const {
    label
  } = (0, _useLabel.default)(initialLabel, {
    ...props,
    id,
    value: value
  });
  const handleMinChange = e => {
    e.preventDefault();
    const newMinVal = Math.min(+e.target.value, maxValue - step);
    setMinValue(newMinVal);
    if (typeof onChange === 'function') {
      onChange({
        min: newMinVal,
        max: maxValue
      });
    }
  };
  const handleMaxChange = e => {
    e.preventDefault();
    const newMaxVal = double ? Math.max(+e.target.value, minValue + step) : e.target.value;
    setMaxValue(newMaxVal);
    if (typeof onChange === 'function') {
      onChange({
        min: minValue,
        max: newMaxVal
      });
    }
  };
  const setCurrency = data => /*#__PURE__*/_react.default.createElement(_InputCurrency.default, {
    value: Number(data),
    locale: locale,
    displayAsText: true
  });
  const setSuffix = data => /*#__PURE__*/_react.default.createElement(_InputNumber.default, {
    displayAsText: true,
    value: Number(data),
    suffix: displaySuffix,
    locale: locale,
    readOnly: true
  });
  const formatNumber = data => /*#__PURE__*/_react.default.createElement(_InputNumber.default, {
    displayAsText: true,
    value: Number(data),
    locale: locale,
    readOnly: true
  });
  const displayValue = val => displayCurrency ? setCurrency(val) : displaySuffix ? setSuffix(val) : formatNumber(val);
  const minPos = (minValue - min) / (max - min) * 100;
  const maxPos = (maxValue - min) / (max - min) * 100;
  const containerClasses = (0, _clsx.default)('uk-form-item', 'uk-range-slider',
  // (helper.length > 0 || error) && 'has-helper',
  // error && 'has-error',
  disabled && 'disabled', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__container"
  }, leftCustomEdge && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__left-value"
  }, leftCustomEdge), leftEdge !== 'hide' && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__left-value"
  }, displayValue(leftEdge === 'min' ? min : double ? minValue : maxValue)), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__inputs" + (displayTooltip ? ' uk-range-slider__inputs--with-tooltip' : '')
  }, double && /*#__PURE__*/_react.default.createElement("input", {
    type: "range",
    value: minValue,
    min: min,
    max: max,
    step: step,
    onChange: handleMinChange,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "range",
    value: maxValue,
    min: min,
    max: max,
    step: step,
    onChange: handleMaxChange,
    disabled: disabled
  }), double && /*#__PURE__*/_react.default.createElement("div", {
    className: "value value--min",
    style: {
      left: minPos + "%"
    }
  }, displayValue(minValue)), /*#__PURE__*/_react.default.createElement("div", {
    className: "value value--max",
    style: {
      left: maxPos + "%"
    }
  }, displayValue(maxValue))), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__controls"
  }, double && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__handle",
    style: {
      left: minPos + "%"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__track"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__track-inner",
    style: {
      left: minPos + "%",
      right: 100 - maxPos + "%"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__handle",
    style: {
      left: maxPos + "%"
    }
  }))), rightEdge !== 'hide' && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__right-value"
  }, displayValue(rightEdge === 'max' ? max : maxValue)), rightCustomEdge && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__right-value"
  }, rightCustomEdge)), helper.length > 0 && /*#__PURE__*/_react.default.createElement("small", {
    className: "uk-form-item__helper"
  }, helper));
};

// const RangeSliderOld = (props) => {
//     const {
//         id: controlledId,
//         name,
//         value: controlledValue,
//         label: initialLabel,
//         helper,
//         min,
//         max,
//         displayTooltip,
//         readOnly,
//         disabled,
//         required,
//         onChange,
//         onError,
//         className,
//         locale,
//         displayCurrency,
//         displaySuffix,
//         onKeyUp,
//         edgeRightValue,
//         edgeMinValue,
//         edgeMaxValue,
//         widthTrack,
//         ...attributes
//     } = props;
//     const singleRangeRef = React.useRef(name);
//     const id = React.useRef(useRandomId(controlledId)).current;
//     const [value, setValue] = React.useState(controlledValue);
//     const tooltipRef = React.useRef(null);
//     const [error, setError] = React.useState(false);

//     const [errors] = useFormElementValidation(value, {
//         required,
//     });
//     const { label } = useLabel(initialLabel, { ...props, id, value: value });

//     React.useEffect(() => setValue(controlledValue || 0), [controlledValue]);

//     React.useEffect(() => {
//         setError(errors.length > 0);
//         if (typeof onError === 'function') {
//             onError({
//                 name: singleRangeRef.current.name,
//                 errors: errors.length ? errors : [],
//             });
//         }
//     }, [errors, onError]);

//     const getPercent = useCallback((value) => Math.round(((value - min) / (max - min)) * 100), [min, max]);

//     useEffect(() => {
//         const valuePercent = getPercent(value);

//         if (tooltipRef.current) {
//             tooltipRef.current.style.transform = 'translateX(-50%)';
//             tooltipRef.current.style.left = `${valuePercent}%`;
//         }
//     }, [value, getPercent]);

//     const handleChange = (event) => {
//         setValue(Number(event.target.value));
//     };

//     const showTooltip = (ref) => {
//         if (ref.current) {
//             ref.current.style.display = 'block';
//         }
//     };

//     const hideTooltip = (ref) => {
//         if (ref.current) {
//             ref.current.style.display = 'none';
//         }
//     };

//     const containerClasses = clsx(
//         'uk-form-item',
//         'uk-range-slider',
//         (helper.length > 0 || error) && 'has-helper',
//         error && 'has-error',
//         disabled && 'disabled',
//         className
//     );

//     const arrowCodes = {
//         up: 38,
//         down: 40,
//         right: 39,
//         left: 37,
//     };

//     const setCurrency = (data) => <InputCurrency value={Number(data)} locale={locale} displayAsText />;
//     const setSuffix = (data) => (
//         <InputNumber displayAsText value={Number(data)} suffix={displaySuffix} locale={locale} readOnly />
//     );
//     const formatNumber = (data) => <InputNumber displayAsText value={Number(data)} locale={locale} readOnly />;

//     const onDone = (event) => {
//         setValue(Number(event.target.value));
//         if (typeof onChange === 'function') {
//             onChange(Number(event.target.value));
//         }
//     };

//     const handleKeyUp = (event) => {
//         const {
//             keyCode,
//             target: { value },
//         } = event;

//         if (
//             keyCode === arrowCodes.up ||
//             keyCode === arrowCodes.down ||
//             keyCode === arrowCodes.right ||
//             keyCode === arrowCodes.left
//         ) {
//             setValue(Number(value));
//             if (typeof onKeyUp === 'function') {
//                 onKeyUp(Number(value));
//             }
//         }
//     };

//     return (
//         <div>

//             <div className={containerClasses}>
//                 {label}
//                 <div className="uk-range-slider__container">
//                     {edgeMinValue && (
//                         <div className="uk-range-slider__edge-value uk-range-slider__left-value">
//                             {displayCurrency ? setCurrency(min) : displaySuffix ? setSuffix(min) : formatNumber(min)}
//                         </div>
//                     )}
//                     <div className="uk-range-slider__inputs" style={widthTrack ? { minWidth: widthTrack } : {}}>
//                         <input
//                             ref={singleRangeRef}
//                             type="range"
//                             id={id}
//                             name={name}
//                             min={min}
//                             max={max}
//                             value={value}
//                             className="range"
//                             disabled={disabled || readOnly}
//                             aria-valuemin={min}
//                             aria-valuemax={max}
//                             aria-valuenow={value}
//                             aria-labelledby={`label-${id}`}
//                             onChange={handleChange}
//                             onMouseOver={() => showTooltip(tooltipRef)}
//                             onMouseOut={() => hideTooltip(tooltipRef)}
//                             onFocus={() => showTooltip(tooltipRef)}
//                             onBlur={() => hideTooltip(tooltipRef)}
//                             onMouseUp={onDone}
//                             onTouchEnd={onDone}
//                             onKeyUp={handleKeyUp}
//                             {...attributes}
//                         />
//                         {displayTooltip && (
//                             <div ref={tooltipRef} className="tooltip">
//                                 {displayCurrency ? setCurrency(value) : displaySuffix ? setSuffix(value) : formatNumber(value)}
//                             </div>
//                         )}
//                     </div>
//                     {edgeMaxValue && (
//                         <div className="uk-range-slider__edge-value uk-range-slider__right-value">
//                             {displayCurrency ? setCurrency(max) : displaySuffix ? setSuffix(max) : formatNumber(max)}
//                         </div>
//                     )}
//                     {edgeRightValue && (
//                         <div className="uk-range-slider__edge-value uk-range-slider__value">
//                             {displayCurrency ? setCurrency(value) : displaySuffix ? setSuffix(value) : formatNumber(value)}
//                         </div>
//                     )}
//                 </div>
//                 {(helper.length > 0 || error) && <small className="uk-form-item__helper">{error || helper}</small>}
//             </div>
//         </div>
//     );
// };

RangeSlider.propTypes = {
  /**
   * ID of the RangeSlider (used to bind the label to the Input)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the RangeSlider (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Default value of the RangeSlider
   */
  value: _propTypes.default.any,
  /**
   * Label of the RangeSlider
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Minimum value of the RangeSlider
   */
  min: _propTypes.default.number,
  /**
   * Maximun value of the RangeSlider
   */
  max: _propTypes.default.number,
  /**
   * Set the RangeSlider as read-only
   */
  readOnly: _propTypes.default.bool,
  /**
   * Set the RangeSlider as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the RangeSlider as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   * Invoked AFTER new value had been set by the RangeSlider
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   * Display current value when hover the thumb
   */
  displayTooltip: _propTypes.default.bool,
  /**
   * Set the currency or number formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),
  /**
   * Display value en currency format.
   */
  displayCurrency: _propTypes.default.bool,
  /**
   * Add suffix after the number.
   */
  displaySuffix: _propTypes.default.string,
  /**
   * Callback function onKeyUp
   */
  onKeyUp: _propTypes.default.func,
  /**
   * Display output value
   */
  edgeRightValue: _propTypes.default.bool,
  /**
   * Display min value on the left side
   */
  leftEdge: _propTypes.default.oneOf(['min', 'value', 'hide']),
  /**
   * Display custom String on the far left side
   */
  leftCustomEdge: _propTypes.default.string,
  /**
   * Display max value on the right side
   */
  rightEdge: _propTypes.default.oneOf(['max', 'value', 'hide']),
  /**
   * Display custom String on the far right side
   */
  rightCustomEdge: _propTypes.default.string
};
RangeSlider.defaultProps = {
  helper: '',
  readOnly: false,
  disabled: false,
  required: false,
  name: 'single-range',
  min: 0,
  max: 100,
  value: 0,
  displayTooltip: true,
  displayCurrency: false,
  displaySuffix: '',
  leftCustomEdge: undefined,
  rightCustomEdge: undefined,
  leftEdge: 'min',
  rightEdge: 'max',
  locale: 'en'
};
var _default = exports.default = RangeSlider;